import { PageLoading } from '@ant-design/pro-components';
import { Skeleton } from 'antd';

const Loading: React.FC = () => (
  <PageLoading />
);

export default Loading;
